import React from 'react';
import {parseDate} from "../../../utilities/data/parser";
import HeaderSection from "./UI/HeaderSection";
import Row from "../../UI/Structure/Row";
import HorizontalLabelledField from "../../UI/Fields/HorizontalLabelledField";
import RowsDisplay from "./Rows/RowsDisplay";
import BalanceRecap from "../Movements/BalanceRecap";

const LotHeaderDisplay = ({header, rows, showPrices = true,showComplete = true, showNotes = true, showRows = true, collapsable = false, defaultOpen = true, balance}) => {

    const fmt2 = (v) => (v !== null && v !== undefined && v !== '' && !isNaN(Number(v)) ? Number(v).toFixed(2) : v);

    return (
        <div className="">
            {header.daticompleti === "0" && showComplete &&
            <div className="font-bold text-red-600 text-center text-lg">ATTENZIONE: DATI NON COMPLETI</div>
            }
            <HeaderSection label="Dettagli lotto" collapsable={collapsable} className="mb-1" defaultOpen={defaultOpen}>
                <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6">
                    <HorizontalLabelledField label="Nr Lotto" className="flex-1">{header.nrlotto}</HorizontalLabelledField>
                    <HorizontalLabelledField label="Eseguito da" className="flex-1">Utente</HorizontalLabelledField>
                    <HorizontalLabelledField label="Fornitore" className="flex-1">{header.supplier.name}</HorizontalLabelledField>
                    <HorizontalLabelledField label="Valuta" className="flex-1">{header.valuta}</HorizontalLabelledField>
                    <HorizontalLabelledField label="Documento in ingresso" className="col-span-2">
                        <Row>
                            <div>{header.document.type.nome ?? header.document.type.name} {header.nrdocfor} del {parseDate(header.datadocfor)}</div>
                        </Row>
                    </HorizontalLabelledField>
                    <HorizontalLabelledField label="Unità di misura superficie" className="flex-1">{header.um.name}</HorizontalLabelledField>
                    <HorizontalLabelledField label="Valore di cambio EUR-USD" className="flex-2">
                        <div>{fmt2(header.eur_usd)}</div>
                    </HorizontalLabelledField>
                    {header.spesedogana && (
                        <HorizontalLabelledField label="Spese Dogana" className="flex-1">{fmt2(header.spesedogana)}</HorizontalLabelledField>
                    )}
                    {header.docspesedogana && (
                        <HorizontalLabelledField label="Doc. Spese Dogana" className="flex-1">{header.docspesedogana}</HorizontalLabelledField>
                    )}
                    {header.spesedazio && (
                        <HorizontalLabelledField label="Spese Dazio" className="flex-1">{fmt2(header.spesedazio)}</HorizontalLabelledField>
                    )}
                    {header.docspesedazio && (
                        <HorizontalLabelledField label="Doc. Spese Dazio" className="flex-1">{header.docspesedazio}</HorizontalLabelledField>
                    )}
                    {header.venditacroste && (
                        <HorizontalLabelledField label="Vendita Croste" className="flex-1">{fmt2(header.venditacroste)}</HorizontalLabelledField>
                    )}
                    {header.datavenditacroste && (
                        <HorizontalLabelledField label="Data Vendita Croste" className="flex-1">{parseDate(header.datavenditacroste)}</HorizontalLabelledField>
                    )}
                    {header.docvenditacroste && (
                        <HorizontalLabelledField label="Doc. Vendita Croste" className="flex-1">{header.docvenditacroste}</HorizontalLabelledField>
                    )}
                </div>
            </HeaderSection>

            {showRows && rows &&
            <HeaderSection label="Righe" collapsable={collapsable} className="mb-1" defaultOpen={defaultOpen}>
                <RowsDisplay rows={rows} />
            </HeaderSection>}

            {showNotes &&
            <HeaderSection label="Note">
                <div>{header.note ? header.note : <div className="text-gray-400">Nessuna nota inserita</div>}</div>
                {balance && (
                    <div className="mt-2">
                        <BalanceRecap/>
                    </div>
                )}
            </HeaderSection>
            }


            {showPrices &&
            <>
                <Row>
                    <HeaderSection label="Spese Dogana" className="flex-1">
                        <Row>
                            <HorizontalLabelledField label="Importo">{header.spesedogana}</HorizontalLabelledField>
                            <HorizontalLabelledField label="Riferimenti">{header.docspesedogana}</HorizontalLabelledField>
                        </Row>
                    </HeaderSection>

                    <HeaderSection label="Spese Dazio" className="flex-1">
                        <Row>
                            <HorizontalLabelledField label="Importo">{header.spesedazio}</HorizontalLabelledField>
                            <HorizontalLabelledField label="Riferimenti">{header.docspesedazio}</HorizontalLabelledField>
                        </Row>
                    </HeaderSection>
                </Row>

                <HeaderSection label="Vendita Croste">
                    <Row>
                        <HorizontalLabelledField label="Importo">{header.venditacroste}</HorizontalLabelledField>
                        <HorizontalLabelledField label="Data">{parseDate(header.datavenditacroste)}</HorizontalLabelledField>
                        <HorizontalLabelledField label="Riferimenti">{header.docvenditacroste}</HorizontalLabelledField>
                    </Row>
                </HeaderSection>
            </>
            }
        </div>
    );
};

export default LotHeaderDisplay;